/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { PlayerDetailItemFragment } from '@amf/shared/types/graphql';
import { useTranslate } from '@tolgee/react';
import PersonHeader from '@amf/shared/components/person/PersonHeader';
import Link from 'next/link';
import CountryFlag from 'react-country-flag';
import { getCountryISO2 } from '@amf/shared/utils/country';

interface PlayerHeaderProps {
  player: PlayerDetailItemFragment;
  prefixes: { team: string };
  showFacr?: boolean;
}

function PlayerHeader({ player, prefixes, showFacr }: PlayerHeaderProps) {
  const { t } = useTranslate();
  return (
    <PersonHeader title={t('player.detail.page')} person={player} prefixes={{}}>
      <ul>
        {player.birthCountry && (
          <li>
            <label>{t('player.info.birthCountry')}</label>
            <strong>
              <CountryFlag svg countryCode={getCountryISO2(player.birthCountry)} />
              {player.birthCountry}
            </strong>
          </li>
        )}
        <li>
          <label>{t('player.info.age.title')}</label>
          <strong>{t('player.info.age', { age: player.age })}</strong>
        </li>
        <li>
          <label>{t('player.info.gender')}</label>
          <strong>{t(`player.info.gender.${player.gender}`)}</strong>
        </li>
        {showFacr && (
          <li>
            <label>{t('player.info.facr')}</label>
            <strong>{player.facr ? t('player.info.facr.yes') : t('player.info.facr.no')}</strong>
          </li>
        )}
        {player.trainerLicense && (
          <li>
            <label>{t('player.info.trainer')}</label>
            <strong>{t(`player.info.trainer.license.${player.trainerLicense}`)}</strong>
          </li>
        )}
        {player.allCurrentTeams.map((team, key) => (
          <li key={team.id}>
            {player.allCurrentTeams.length === 1 && <label>{t('player.info.currentTeam')}</label>}
            {player.allCurrentTeams.length > 1 && key === 0 && (
              <label>{t('player.info.currentTeams')}</label>
            )}
            {player.allCurrentTeams.length > 1 && key > 0 && <label>&nbsp;</label>}
            <div>
              <Link href={`${prefixes.team}/${team.id}`}>
                <a>
                  {team.club.brandUrl && <img src={team.club.brandUrl} alt={team.club.name} />}
                  {team.name}
                </a>
              </Link>
            </div>
          </li>
        ))}
      </ul>
    </PersonHeader>
  );
}

export default PlayerHeader;
